<template>
  <div class="">
    <GalleryBar :title="gallery.name"
                v-if="gallery.name"/>
    <div class="gallery-media-container">
      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" label="Spinning"/>
      </div>
      <div v-else-if="!currentTabData || currentTabData.length === 0" class="gallery-no-media">
        No media available
      </div>
      <div v-else>

          <div class="horizontal-scroll-wrapper blend">
            <div class="horizontal-scroll-container no-scroll cursor-pointer" @click="expandGallery">
              <div class="row flex-nowrap w-100 align-items-center">
                <div class="col col-fixed" v-for="(media, index) in mediaList" :key="index">
                  <MediaItem :media="media"
                             :index="index"
                             :cart-enabled="false"
                             :gallery="gallery"
                             :favorite-enabled="false"
                  />
                </div>
                <div v-if="canExpand" class="count-badge">{{ photosCount }} {{ $t('gallery.misc.elements') }}
                  <Icon class="ml-2" name="arrowRight" width="18"/>
                </div>
              </div>
            </div>
          </div>


      </div>
    </div>
  </div>
</template>

<script>
import BaseDisplayType from './BaseDisplayType.vue'
import '../styles/gallery-common.css'
import {mapGetters} from "vuex";
import GalleryBar from "@/domain/galleryTree/components/GalleryBar.vue";
import MediaItem from "@/domain/galleryTree/components/MediaItem.vue";

export default {
  name: 'CompactThumbGallery',
  components: {MediaItem, GalleryBar},
  extends: BaseDisplayType,

  data() {
    return {
      // Data is now fetched with the correct page_size
    }
  },

  computed: {
    ...mapGetters('galleryTree', ['rootGalleryId']),
    displayType() {
      return 'compact'
    },

    paginationType() {
      return 'none'
    },

    photosCount() {
      // Get total count from the paginated response
      return this.gallery && this.gallery.num_media
    },
    canExpand() {
      return this.gallery && this.gallery.can_expand === true
    },
  },

  methods: {
    getPaginationSize() {
      return 25
    },

    openGallery() {
      // Add safety check for gallery
      if (!this.gallery || !this.gallery.id) {
        console.error('Gallery is undefined or missing ID:', this.gallery);
        return;
      }

      if (!this.canExpand) {
        return;
      }

      // Emit with just the gallery ID
      this.$emit('openGallery', this.gallery.id);
    },

    expandGallery() {
      if (this.canExpand) {
        this.openGallery()
      }
    },

    // Override notification_ready handler for CompactThumb behavior
    async handleNotificationReady(payload) {
      const {galleryId, notificationData} = payload

      // Only handle notifications for this gallery
      if (galleryId !== this.gallery.id) {
        return
      }
      try {
        // Check if there are actually new media
        const checkResult = await this.checkNewMedia({
          galleryId: this.gallery.id,
          currentData: this.gallery,
          fullRefresh: notificationData.type === 'picacode_update'
        })

        if (checkResult && checkResult.hasNewMedia) {
          console.log(`Auto-refreshing CompactThumb for gallery ${galleryId}`)
          // Auto-refresh the media data instead of showing popup
          await this.loadMedia(1, false)
        }

      } catch (error) {
        console.error('Error in CompactThumb auto-refresh:', error)
      }
    }
  }
}
</script>

<style scoped>
/* Component-specific styles only */
.gallery-photo-item.clickable {
  cursor: pointer;
}

.gallery-photo-item:not(.clickable) {
  cursor: default;
}
</style>